// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__z5Y-7","actions":"GroupTable_actions__eQLv-","deleteModalFooter":"GroupTable_deleteModalFooter__2I9np"};